/* LASTU – Ruskatunturi-alatunniste (DEMO 11.10.2026)
   Piirtää maalauksellisen, rakeisen ruskamaiseman kerran Web Workerissa ja
   asettaa sen canvasille. Ei animaatiota. Piirto käynnistyy vasta kun
   alatunniste on ~800 px päässä näkymästä, ja uudelleen vain jos leveys muuttuu. */
(function () {
  'use strict';
  var root = document.querySelector('[data-lrf]');
  if (!root || root.__lrf) return; root.__lrf = 1;
  var cv = root.querySelector('.lrf__cv'), inner = root.querySelector('[data-lrf-in]');

  function painter() {
    /* ajetaan workerissa – kaikki tarvittava tämän funktion sisällä */
    function h2(x,y){var h=(x*374761393+y*668265263)|0;h=Math.imul(h^(h>>>13),1274126177);return((h^(h>>>16))>>>0)/4294967296}
    function vn(x,y){var xi=Math.floor(x),yi=Math.floor(y),xf=x-xi,yf=y-yi,u=xf*xf*(3-2*xf),v=yf*yf*(3-2*yf);var a=h2(xi,yi),b=h2(xi+1,yi),c=h2(xi,yi+1),d=h2(xi+1,yi+1);return a+(b-a)*u+(c-a)*v+(a-b-c+d)*u*v}
    function fbm(x,y,o){var s=0,a=0.5,f=1,n=0;for(var i=0;i<o;i++){s+=a*vn(x*f,y*f);n+=a;f*=2.03;a*=0.5}return s/n}
    function ss(a,b,t){t=(t-a)/(b-a);t=t<0?0:t>1?1:t;return t*t*(3-2*t)}
    function C(h){return[parseInt(h.slice(1,3),16)/255,parseInt(h.slice(3,5),16)/255,parseInt(h.slice(5,7),16)/255]}
    function mix(a,b,t){return[a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t,a[2]+(b[2]-a[2])*t]}
    function mul(a,k){return[a[0]*k,a[1]*k,a[2]*k]}
    var SKY_T=C('#dde3f1'),SKY_B=C('#f7ddd2'),GLOW=C('#fbe7cf'),HAZE=C('#f1d6d4'),F1=C('#a7a2cf'),F1L=C('#cdbfdc'),F2=C('#8f789f'),F2R=C('#b9776e'),
        RED=C('#c2452e'),ORA=C('#df8a3d'),OCH=C('#e3b459'),MAU=C('#8e6578'),DRED=C('#8f2f2b'),BUR=C('#6e2a33'),LICH=C('#cdbb8c'),SPR=C('#34463f');
    onmessage = function (e) {
      var W=e.data.w,H=e.data.h,TB=e.data.tb,S=Math.max(520,Math.min(W,1100));
      /* U = maiseman mittakaava, Y0 = "horisontin" kantaviiva; kauimmaiset laet nousevat hieman tekstin taakse */
      var U=(H-TB)/0.68,Y0=H-0.56*U;
      function ridge(k,x){var u=x/S,q=x/W;
        if(k===0)return Y0+U*0.02-U*0.12*fbm(u*1.3+3.1,0.7,3)-U*0.07*Math.exp(-Math.pow((q-0.62)/0.2,2))-U*0.04*Math.exp(-Math.pow((q-0.12)/0.14,2));
        if(k===1)return Y0+U*0.12+U*0.07*q-U*0.12*fbm(u*1.6+9.4,2.2,4)-U*0.05*Math.exp(-Math.pow((q-0.25)/0.16,2));
        if(k===2)return Y0+U*0.25+U*0.07*(1-q)-U*0.09*fbm(u*2.1+17.1,4.6,4);
        return Y0+U*0.47-U*0.11*q-U*0.05*fbm(u*3+27.3,6.9,4)}
      var R=[[],[],[],[]],k,x,y;for(k=0;k<4;k++)for(x=-2;x<W+3;x++)R[k][x+2]=ridge(k,x);
      var d=new Uint8ClampedArray(W*H*4);
      for(x=0;x<W;x++){var r0=R[0][x+2],r1=R[1][x+2],r2=R[2][x+2],r3=R[3][x+2],sl0=R[0][x+4]-R[0][x],sl1=R[1][x+4]-R[1][x],sl2=R[2][x+4]-R[2][x],u=x/S;
        var cl=fbm(u*5+70,1.3,2),spr=(h2(x>>2,77)<0.5*ss(0.5,0.7,cl))?(2.5+h2(x>>2,78)*4.5):0,sprC=((x>>2)<<2)+2,spr2=(h2(x>>2,91)<0.35*ss(0.55,0.75,fbm(u*4+90,2.1,2)))?(1.6+h2(x>>2,92)*2.6):0;
        for(y=0;y<H;y++){var c,v=y/S,dd,L,tex,p1,p2,lit,str;
          if(y<r0){c=mix(SKY_T,SKY_B,Math.pow(Math.max(0,y)/r0,1.35));var g=Math.exp(-Math.pow((u-0.72*W/S)/0.55,2)-Math.pow((y-r0)/(U*0.22),2));c=mix(c,GLOW,g*0.55)}
          else if(y<r1){dd=y-r0;L=(r1-r0)||1;tex=fbm(u*7,v*7,5);var gul=fbm(u*26,v*4,3);lit=0.5-sl0*0.06+(tex-0.5)*0.9;
            c=mix(F1,F1L,ss(0.25,0.85,lit));c=mix(c,mix(F1L,[1,1,1],0.3),ss(0.62,0.8,gul)*0.35*(1-ss(0,U*0.1,dd)));c=mix(c,HAZE,0.28+0.6*ss(0,Math.max(L,U*0.12),dd))}
          else if(y<r2){dd=y-r1;L=(r2-r1)||1;tex=fbm(u*6+5,v*6,5);var pat=fbm(u*3.2+11,v*3.2,4);lit=0.5-sl1*0.05+(tex-0.5);
            c=mix(mul(F2,0.92),mix(F2,F1L,0.35),ss(0.2,0.85,lit));c=mix(c,F2R,ss(0.48,0.68,pat)*0.75);c=mix(c,HAZE,0.16+0.55*ss(0,Math.max(L,U*0.1),dd))}
          else if(y<r3){dd=y-r2;L=(r3-r2)||1;p1=fbm(u*3.5+31,v*3.5,4);p2=fbm(u*9+41,v*9,4);tex=fbm(u*14,v*14,3);lit=0.55-sl2*0.05+(tex-0.5)*0.8;
            c=mix(RED,ORA,ss(0.35,0.65,p1));c=mix(c,OCH,ss(0.58,0.78,p2)*0.8);c=mix(c,MAU,ss(0.62,0.8,1-p1)*0.6);c=mul(c,0.82+0.3*ss(0,1,lit));
            str=fbm(u*40,v*5,2);c=mul(c,0.96+0.08*str);c=mix(c,HAZE,0.05+0.42*ss(L*0.25,Math.max(L,U*0.08),dd))}
          else{dd=y-r3;p1=fbm(u*4+51,v*4,4);p2=fbm(u*12+61,v*12,4);tex=fbm(u*22,v*22,3);
            c=mix(DRED,ORA,ss(0.42,0.7,p1)*0.8);c=mix(c,BUR,ss(0.5,0.75,1-p2)*0.55);c=mix(c,LICH,ss(0.66,0.82,p2)*0.6);
            c=mul(c,0.86+0.2*tex);str=fbm(u*55,v*7,2);c=mul(c,0.95+0.1*str);c=mul(c,1-0.18*ss(0,H-r3,dd));c=mix(c,HAZE,0.04)}
          if(spr>0){var hy=r3+2-y,hh=spr*2.8;if(hy>0&&hy<hh){var hw=(1-hy/hh)*spr*0.5*(0.75+0.5*h2(x,y>>1))+0.35;if(Math.abs(x-sprC)<hw)c=mix(SPR,HAZE,0.12+0.1*h2(sprC,3))}}
          if(spr2>0&&y>=r2-12&&y<r3){var hy2=r2+1.5-y,hh2=spr2*2.8;if(hy2>0&&hy2<hh2){var hw2=(1-hy2/hh2)*spr2*0.5*(0.75+0.5*h2(x,y>>1))+0.3;if(Math.abs(x-sprC)<hw2)c=mix(SPR,HAZE,0.42)}}
          var n=h2(x,y)-0.5,n2=h2(x+57,y+113)-0.5,n3=h2(x+911,y+7)-0.5,i=(y*W+x)*4;
          d[i]=(c[0]+n*0.11+n2*0.05)*255;d[i+1]=(c[1]+n*0.11+n3*0.05)*255;d[i+2]=(c[2]+n*0.11-n2*0.05)*255;d[i+3]=255}}
      postMessage({w:W,h:H,d:d},[d.buffer]);
    };
  }

  var worker = null, lastW = 0, busy = false;
  function getWorker() {
    if (worker) return worker;
    try {
      var url = URL.createObjectURL(new Blob(['(' + painter.toString() + ')()'], { type: 'text/javascript' }));
      worker = new Worker(url);
      worker.onmessage = function (e) {
        busy = false;
        cv.width = e.data.w; cv.height = e.data.h;
        cv.getContext('2d').putImageData(new ImageData(e.data.d, e.data.w, e.data.h), 0, 0);
        cv.classList.add('is-on');
      };
    } catch (err) { worker = null; }
    return worker;
  }
  function render() {
    var w = root.clientWidth, h = root.clientHeight;
    if (!w || !h || w === lastW || busy) return;
    var wk = getWorker(); if (!wk) return;   /* ilman workeria jää CSS-liukuväri */
    lastW = w; busy = true;
    var tb = inner.offsetTop + inner.offsetHeight;
    wk.postMessage({ w: w, h: h, tb: tb });
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); render(); } }, { rootMargin: '800px 0px' });
    io.observe(root);
  } else { render(); }
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (cv.classList.contains('is-on') || lastW) render(); }, 250); });
})();
